import { CompanionRole } from '@konsolenkost-de/acquisition_store_server_sdk_vue';
import { type MaybeRef } from 'vue';
import { type DisplayBadgeType } from '../style/useDisplayBadgeClass';
import { useCompanionRoleInfo } from './useCompanionRoleInfo';

export type CompanionRoleTemplateDefinition = {
  key: CompanionRole;
  roles: CompanionRole[];
};

export type CompanionRoleTemplateInfo = CompanionRoleTemplateDefinition & {
  title: string;
  description: string;
};

export const COMPANION_ROLE_TEMPLATES: CompanionRoleTemplateDefinition[] = [
  {
    key: CompanionRole.FILE_SYNC,
    roles: [CompanionRole.FILE_SYNC],
  },
];

const COMPANION_ROLE_TEMPLATE_INFO: Record<
  CompanionRole,
  Pick<CompanionRoleTemplateInfo, 'title' | 'description'>
> = {
  [CompanionRole.FILE_SYNC]: {
    title: 'companion.roles.file_sync.title',
    description: 'companion.roles.file_sync.description',
  },
};

export const useCompanionRoleTemplateInfo = (
  colorType: MaybeRef<DisplayBadgeType> = 'badge',
  template?: MaybeRef<CompanionRole>,
) => {
  const {
    companionRoleInfo,
    getCompanionRoleClass,
    getCompanionRoleColor,
    getCompanionRoleIcon,
    getCompanionRoleTitle,
    getCompanionRoleInfo,
  } = useCompanionRoleInfo(colorType, template);

  const companionRoleTemplates: CompanionRoleTemplateInfo[] = COMPANION_ROLE_TEMPLATES.map(
    (item) => ({
      ...item,
      ...COMPANION_ROLE_TEMPLATE_INFO[item.key],
    }),
  );

  return {
    companionRoleTemplateInfo: companionRoleInfo,
    companionRoleTemplates,
    getCompanionRoleTemplateTitle: getCompanionRoleTitle,
    getCompanionRoleTemplateDescription: (templateValue: CompanionRole) =>
      getCompanionRoleTitle(templateValue, 'description'),
    getCompanionRoleTemplateClass: getCompanionRoleClass,
    getCompanionRoleTemplateColor: getCompanionRoleColor,
    getCompanionRoleTemplateIcon: getCompanionRoleIcon,
    getCompanionRoleTemplateInfo: getCompanionRoleInfo,
  };
};
